import { filterVisibleItems } from '../../utils/common'

import { RequestTableExportOptionValue } from './Request.constants.actions'

export function getExportOptions({
  permissions,
  selectAllPages,
  selectedIds,
  t,
}) {
  const isSelectedEmpty = !selectAllPages && selectedIds.length === 0

  return filterVisibleItems([
    {
      disabled: isSelectedEmpty,
      isVisible: true,
      label: t('RequestTable.exportTable'),
      tooltipContent: isSelectedEmpty
        ? t('RequestTable.ExportOptionDisabledTooltipKey')
        : null,
      value: RequestTableExportOptionValue.ExportTable,
    },
    {
      disabled: isSelectedEmpty,
      isVisible: permissions.can_export_zip,
      label: t('RequestTable.ExportEmailsFilesChatsOptionKey'),
      tooltipContent: isSelectedEmpty
        ? t('RequestTable.ExportOptionDisabledTooltipKey')
        : null,
      value: RequestTableExportOptionValue.ExportEmailsFilesChats,
    },
    {
      isVisible: permissions.can_export_invoices,
      label: t('RequestTable.exportInvoice'),
      value: RequestTableExportOptionValue.ExportInvoice,
    },
  ])
}
